
























import { Component, Vue } from 'vue-property-decorator'
import {
  getToday,
  past7Day,
  past30Day,
  pastWeek,
  pastMonth,
} from '@/utils/formValidate'
import {
  getDataOverView,
  getTurnoverStatistics,
  getUserStatistics,
  getOrderStatistics,
  getTop,
} from '@/api/index'
// 组件
// 标题
import TitleIndex from './components/titleIndex.vue'
// 营业额统计
import TurnoverStatistics from './components/turnoverStatistics.vue'
// 用户统计
import UserStatistics from './components/userStatistics.vue'
// 订单统计
import OrderStatistics from './components/orderStatistics.vue'
// 排名
import Top from './components/top10.vue'
@Component({
  name: 'Dashboard',
  components: {
    TitleIndex,
    TurnoverStatistics,
    UserStatistics,
    OrderStatistics,
    Top,
  },
})
export default class extends Vue {
  private overviewData = {} as any
  private flag = 0
  private tateData: string[] = []
  private turnoverData = {} as any
  private userData = {}
  private orderData = {
    data: {},
  } as any
  private top10Data = {}
  created() {
    this.getTitleNum(0)
  }
  // 获取基本数据
  init(begin: string, end: string) {
    this.$nextTick(() => {
      this.getTurnoverStatisticsData(begin, end)
      this.getUserStatisticsData(begin, end)
      this.getOrderStatisticsData(begin, end)
      this.getTopData(begin, end)
    })
  }

  // 获取营业额统计数据
  async getTurnoverStatisticsData(begin: string, end: string) {
    const data = await getTurnoverStatistics({ begin: begin, end: end })
    const turnoverData = data.data.data
    this.turnoverData = {
      dateList: turnoverData.dateList.split(','),
      turnoverList: turnoverData.turnoverList.split(',')
    }
    // this.tateData = this.turnoverData.date
    // const arr = []
    // this.tateData.forEach((val) => {
    //   let date = new Date()
    //   let year = date.getFullYear()
    //   arr.push(year + '-' + val)
    // })
    // this.tateData = arr
  }
  // 获取用户统计数据
  async getUserStatisticsData(begin: string, end: string) {
    const data = await getUserStatistics({ begin: begin, end: end })
    const userData = data.data.data
    this.userData = {
      dateList: userData.dateList.split(','),
      totalUserList: userData.totalUserList.split(','),
      newUserList: userData.newUserList.split(','),
    }
  }
  // 获取订单统计数据
  async getOrderStatisticsData(begin: string, end: string) {
    const data = await getOrderStatistics({ begin: begin, end: end })
    const orderData = data.data.data
    this.orderData = {
      data: {
        dateList: orderData.dateList.split(','),
        orderCountList: orderData.orderCountList.split(','),
        validOrderCountList: orderData.validOrderCountList.split(','),
        //orderCompletionRateList: orderData.orderCompletionRateList.split(','),
      },
      totalOrderCount: orderData.totalOrderCount,
      validOrderCount: orderData.validOrderCount,
      orderCompletionRate: orderData.orderCompletionRate
    }
  }
  // 获取排行数据
  async getTopData(begin: string, end: string) {
    const data = await getTop({ begin: begin, end: end })
    const top10Data = data.data.data
    this.top10Data = {
      nameList: top10Data.nameList.split(',').reverse(),
      numberList: top10Data.numberList.split(',').reverse(),
    }
    console.log(this.top10Data)
  }
  // 获取当前选中的tab时间
  getTitleNum(index: number) {
    this.flag = index

    const today = new Date()
    const formatDate = (date: Date) => {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    }

    const todayStr = formatDate(today)
    let startDate = new Date(today)

    switch (index) {
      case 0: // 今日
        this.tateData = [todayStr, todayStr]
        break
      case 1: // 近7日
        startDate.setDate(today.getDate() - 6)
        this.tateData = [formatDate(startDate), todayStr]
        break
      case 2: // 近30日
        startDate.setDate(today.getDate() - 29)
        this.tateData = [formatDate(startDate), todayStr]
        break
      case 3: // 本周
        const dayOfWeek = today.getDay() || 7
        startDate.setDate(today.getDate() - dayOfWeek + 1)
        this.tateData = [formatDate(startDate), todayStr]
        break
      case 4: // 本月
        startDate.setDate(1)
        this.tateData = [formatDate(startDate), todayStr]
        break
    }
    
    this.init(this.tateData[0], this.tateData[1])
  }
}
